import { Box } from '@mui/material';
import ButtonGroupProps from './ButtonGroupModels';

function ButtonGroup({ children, sx }: ButtonGroupProps) {
  return <Box sx={{ display: 'flex', gap: '1.5rem', ...sx }}>{children}</Box>;
}
export default ButtonGroup;
